import SellFaqs, { SellFaqsProps } from "./SellFaqs";

export { SellFaqs, SellFaqsProps };

export default SellFaqs;
